<template>
  <section>
    <div class="row mt-3">
      <div class="col-12">
        <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :href="file.url"
            v-for="(file, index) in files"
          >
            {{ index + 1 }}. {{ file.label }}
            <b-icon icon="images" font-scale="2"></b-icon>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import { IconsPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'

Vue.use(IconsPlugin)
Vue.use(ListGroupPlugin)

export default {
  name: "cartoon",
  data() {
    return {
      files: [
        {
          label: '戒殺四十八問',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/48-questions-about-killing-and-releasing.pdf'
        },
        {
          label:'放生',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/releasing-life.pdf'
        },
        {
          label: '放生問答',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/releasing-life-q-and-a.pdf'
        },
        {
          label: '善待生命',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/treating-life-with-kindness.pdf'
        },
        {
          label: '蓮池大師的故事',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/the-story-of-master-lianchi.pdf'
        },
        // {
        //   label: '蓮池大師戒殺放生文圖說',
        //   url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/master-lianchi-on-abstaining-from-killing-and-releasing-life.pdf'
        // },
        {
          label: '護生漫畫集',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/protecting-life-comics-collection.pdf'
        },
        {
          label: '護生的故事',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/the-story-of-protecting-life.pdf'
        },
        {
          label: '學佛與素食',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/learning-buddhism-and-vegetarianism.pdf'
        },
        {
          label: '菩薩的故事-戒吃蛤蜊',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/the-story-of-bodhisattva-abstaining-from-eating-clams.pdf'
        },
        {
          label: '護生小品',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/short-stories-about-protecting-life.pdf'
        },
        {
          label: '救護生命的故事',
          url: 'https://www2.budaedu.org/official-website-data/love-life/cartoon/the-story-of-saving-and-protecting-life.pdf'
        }
      ]
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>